import React from 'react';
import OutlinedInput from '@material-ui/core/OutlinedInput';

const CustomOutlinedInput = (props) => <OutlinedInput {...props} />;

export { CustomOutlinedInput as OutlinedInput };
